import React from 'react';

import classes from './styles.module.scss';

export default function Textarea({ ...props }) {
  return <textarea className={classes.Textarea} {...props} />;
}
